import script from "./PasswordExpiredView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordExpiredView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordExpiredView.vue?vue&type=style&index=0&id=1808e32c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1808e32c"]])

export default __exports__